import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import MaterialTable from 'material-table';
import { Button, Box, Input, FormControl } from '@material-ui/core';

import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import PropTypes from 'prop-types';

import useDebounce from '../../../components/global/use-debounce';
import { updateTag } from '../../../actions/admin/tagAction';
import apiService from '../../../services.js/apiService';

const TagsTable = ({ updateTagAction, maxTrendingTags, updateList, updateUpper }) => {
  const [currentOrder, setCurrentOrder] = useState('');
  const [autoFocus, setAutoFocus] = useState(false);
  const [maxTrendRank, setMaxTrendRank] = useState();
  const [search, setSearch] = useState('');
  const [onResetSearch, setOnResetSearch] = useState(false);
  const [tagName, setTagName] = useState('');
  const table = useRef(null);

  const currentStatus = 'approved';
  const pageSize = 10;
  const { searchFocus } = autoFocus;
  const debouncedSearch = useDebounce(search, 500);

  const shouldUpdateUpperTable = (value) => {
    updateUpper(value);
  };

  useEffect(() => {
   setMaxTrendRank(maxTrendingTags);
  }, [maxTrendingTags]);

  useEffect(() => {
    if (!onResetSearch) {
      table.current && table.current.onQueryChange();
    } else {
      setOnResetSearch(false);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    table.current && table.current.onQueryChange();
  }, [tagName, currentStatus, currentOrder]);

  useEffect(() => {
    table.current && table.current.onQueryChange();
  }, [updateList]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setAutoFocus({ searchFocus: true });
  };

  const addToTrending = (tag, maximum) => {
    try {
      const p = new Promise((resolve, reject) => {
        const sendUpdate =  updateTagAction({ name: tag, trendRank: maximum + 1 }, tag);
        if (sendUpdate) {
          resolve(sendUpdate);
          setTagName(tag);
          shouldUpdateUpperTable(true);
        } else { reject('An unexpected error has occured'); }
      });

      p.then(() => {
        toast.success(`Added ${tag} To Trending List`);
        setTagName('');
      }).catch((err) => {
        console.log(err);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-75">
      <MaterialTable
        tableRef={table}
        title=""
        columns={[
          { title: 'Tag', field: 'name', sorting: true },
        ]}
        onChangeRowsPerPage={() => {
          setCurrentOrder('');
          setAutoFocus({  searchFocus: false });
        }}
        data={
          (query) => new Promise(async (resolve, reject) => {
            try {
              query.name = search;
              query.pageSize = pageSize;
              query.pageNo = query.page;
              query.status = currentStatus;
              query.orderDir = currentOrder;
              const result = await apiService.getTags(query);
              let { rows, totalCount } = result;
              const { page } = query;

              if (rows.length === 0 && totalCount !== 0) {
                const resultFirstPage = await apiService.getTags({ ...query, pageNo: 0 });
                rows = resultFirstPage.rows;
              }

              resolve({
                data: rows,
                page,
                totalCount,
              });
            } catch (err) {
              toast.error(err);
              resolve({
                data:       [],
                pageNo:     0,
                totalCount: 0,
              });
            }
          })
        }
        actions={[
          /* overridden */
          {
            icon:    'check',
            tooltip: 'Approve',
            onClick: () => { },
          },
        ]}
        localization={{
          header: {
            actions: 'Add To Trending',
          },
        }}
        options={{
          actionsColumnIndex:  -1,
          search:              false,
          sorting:             true,
          paging:              true,
          pageSize:            10,
          emptyRowsWhenPaging: false,
          size:                '60%',
        }}
        components={{
          Toolbar: (props) => (
            <div>
              <Box p={1} width="50%" style={{ marginTop: '16px' }}>
                <FormControl fullWidth>
                  <Input
                    placeholder="Search Tag by Name"
                    value={search}
                    onChange={handleSearchChange}
                    type="search"
                    startAdornment={(
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    )}
                    autoFocus={searchFocus}
                  />
                </FormControl>
              </Box>
            </div>
          ),
          Action: (props) => (
            <div>
              <Box>
                {
                  (props.data.trendRank === null)
                    ? (
                      <Box pt={1} pb={1}>
                        <Button
                          onClick={(event) => { addToTrending(props.data.name, maxTrendRank); }}
                          color="primary"
                          variant="contained"
                          style={{ textTransform: 'none', width: 100 }}
                          size="medium"
                        >
                          Add
                        </Button>
                      </Box>
                    )
                    : (
                      <Box pt={1} pb={1} mx="auto">
                        <Button
                          onClick={() => null}
                          color="secondary"
                          variant="contained"
                          style={{ textTransform: 'none', width: 100 }}
                          size="medium"
                          disabled
                        >
                          Added
                        </Button>
                      </Box>
                    )
                }
              </Box>
            </div>
          ),
        }}
      />
    </div>
  );
};

TagsTable.propTypes = {
  updateTagAction: PropTypes.func.isRequired,
  maxTrendingTags: PropTypes.number.isRequired,
  updateList:      PropTypes.bool.isRequired,
  updateUpper:     PropTypes.func.isRequired,
};

// map props to redux state (use Chrome Redux DevTools to help identify how state are stored)
function mapStateToProps(state) {
  return {
    tags: state.admin.tag.tags,
  };
}

// map the redux action creators to props
const mapActionToProps = {
  updateTagAction: updateTag,
};

// connect(mapStateToProps, actions to component as props)(component)
export default connect(
  mapStateToProps,
  mapActionToProps,
)(TagsTable);
